<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-home-exp-pie-chart">
    <span class="wy-home-exp-pie-chart-title">{{pieChartData.subtitle}}</span> 
    <div class="wy-panel-pie-chart-inner" :id="chartId">
      <div v-if="pieChartData.displayValue=='N/A' || pieChartData.displayValue==-1" class="display-value">
        <span class="wy-home-exp-pie-chart-subtitle">{{pieChartData.subtitle}}</span>
        <div class="no-data">N/A</div>
      </div>
      <div v-else class="display-value twoNumbers"  :class="{'no-color': markColor(pieChartData.displayValue)=='no-color'}">
        <span v-if="pieChartData.subtitle == 'Experience'" class="wy-home-exp-pie-chart-subtitle">{{title}}</span>
        <span v-if="pieChartData.subtitle == 'Experience'" :class="{'wy-home-exp-pie-green': markColor(pieChartData.displayValue)=='green',
                  'wy-home-exp-pie-yellow': markColor(pieChartData.displayValue)=='yellow',
                  'wy-home-exp-pie-red': markColor(pieChartData.displayValue)=='red',
                  'wy-home-exp-pie-no-color': markColor(pieChartData.displayValue)=='no-color'}">{{pieChartData.displayValue}}
        </span>
        <span v-if="pieChartData.subtitle == 'Experience' && (targetValue || targetValue == 0)" class="wy-home-exp-pie-chart-target">
          <span v-if="markColor(pieChartData.displayValue) == 'no-color'" class="target-percent"></span>
          <span v-else class="target-percent">{{targetValue}}</span>
        </span>

        <span v-if="pieChartData.subtitle == 'Automation'" class="wy-home-exp-pie-chart-subtitle">{{title}}</span>
        <span v-if="pieChartData.subtitle == 'Automation'" :class="{'wy-home-exp-pie-green': markColor(pieChartData.displayValue)=='green',
                  'wy-home-exp-pie-yellow': markColor(pieChartData.displayValue)=='yellow',
                  'wy-home-exp-pie-red': markColor(pieChartData.displayValue)=='red',
                  'wy-home-exp-pie-no-color': markColor(pieChartData.displayValue)=='no-color'}">{{pieChartData.displayValue}}%
        </span>
        <span v-if="pieChartData.subtitle == 'Automation' && (targetValue || targetValue == 0)" class="wy-home-exp-pie-chart-target">
          <span v-if="markColor(pieChartData.displayValue) == 'no-color'" class="target-percent"></span>
          <span v-else class="target-percent">{{targetValue}}%</span>
        </span>

      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';

export default Vue.extend({
  name: 'wy-home-exp-pie-chart',
  props: ['chartId', 'pieChartData', 'title', 'targetKey'],

  data() {
    return {
      module: this,
      loading: false,
      chart: null,
      targetValue: null
    }
  },
  computed: {    
    ...mapGetters(['dataModel', 'companyConfig', 'companyProfileSettings'])
  },
  methods: {
    // numberFormatter(bigNumebr){
    //   return WyUtils.bigNumberFormatter(bigNumebr)
    // },
    markColor(val) {
      if(this.companyProfileSettings && this.companyProfileSettings.targetSettings && this.companyProfileSettings.targetSettings.settings.home 
        && this.companyProfileSettings.targetSettings.settings.home.experienceAutomationSummary.default 
        && Object.keys(this.companyProfileSettings.targetSettings.settings.home.experienceAutomationSummary.default).length > 0) {
          let defaultTargetObject = this.companyProfileSettings.targetSettings.settings.home.experienceAutomationSummary.default.target;
          let returnColor = 'no-color';
          Object.keys(defaultTargetObject).forEach(key => {
            if(key == this.targetKey) {
              let targetObject = defaultTargetObject[key];
              if(targetObject.reverse) {
                returnColor = (val > targetObject.value) ? 'red' : 'green';
              }
              else {
                returnColor = (val > targetObject.value) ? 'green' : 'red';
              }
              this.targetValue = targetObject.value;
            }
          })
          return returnColor;
        }
        else {
          return 'no-color';
        }
    },

    toggleLegend(legendsData) {
      // let mapLagends = WyPanelUtils.mapLagends;
      this.localData = JSON.parse(JSON.stringify(this.pieChartData));
      legendsData.forEach((legendData, index) => {
        if(!legendData.toggle) {
          this.localData.percent[index] = null;
          this.localData.values[index] = null
        }
      })
      this.buildChart('legend');
    },
    
    buildChart(mode) {
      setTimeout(()=>{
        if(this.pieChartData.displayValue == -1) {
          this.pieChartData.displayValue = 'N/A'
        }
        if(!mode) {
          this.localData = JSON.parse(JSON.stringify(this.pieChartData));
        }
        var data = [{
          values: this.localData.values, //[15, 20, 75],]
          // volumes: this.pieChartData.values,
          labels: this.localData.legends, //['English', 'French', 'Spanish'],
          percents: this.localData.percents,
          name: '',
          hole: .7,
          text: '',
          textinfo: "percent",
          texttemplate: "",
          //textposition: "outside",
          textposition: "none",
          type: 'pie',
          hovertemplate: "",
          'marker': {
            'colors': this.localData.legendColors,
            line: {
              color: 'white', 
              width: 0.5
              }
          },
          hoverinfo: 'none',
          }];

        var layout = {
          automargin: true,
          margin: { l: 20, r: 20, t: 50, b: 50, pad: 0},
          annotations: [
          {   
              text: '',
              font: {
                size: 18.65,
                family: 'Helvetica Neue, Helvetica, arial, sans-serif'
              },
              showarrow: false,
              x: 0.5,
              y: 0.5
          }
          ],
          showlegend: false,
          legend: {
              orientation: 'h',
              x: -0.24,
              y: 0,
          },
          
          hoverlabel: {
            align: 'left',
            bgcolor: 'black',
            font: {
              size: 13,
              family: 'Helvetica Neue, Helvetica, arial, sans-serif',
              color: "white"
            },
            namelength: 50,
            bordercolor: 'black',
            },
          height: 340,
          // width: 480,
          // autorange: true,
          // grid: {rows: 1, columns: 2}
        };
        let config = {responsive: true, displayModeBar: false, scrollZoom: false, showTips: false};
        let total = 0;
        data[0].values.forEach(value=>{
          total = total + value
        })
        if(total == 0) {
          data[0].values.push(100)
          data[0].labels.push('no data')
          data[0].marker.colors[data[0].labels.length-1] = "#CCC";
          data[0].textposition = 'none';
          layout.hovermode = false;
        }
        // eslint-disable-next-line no-undef
        Plotly.newPlot(this.chartId, data, layout, config);
      }, 50)
    }
  },

  created() {

  },

  mounted(){
    
    this.buildChart()
  }
});
</script>

<style lang="scss">
  .wy-home-exp-pie-chart {
    .wy-home-exp-pie-chart-title{
      font-size: 1.5em;
      color: var(--site-font-secondary-color);
      // margin-left: 43%;
      position: relative;
      top: 34px;
    }
    .wy-panel-pie-chart-inner{
      position: relative;
      height: 322px;
      cursor: pointer;
      .plot-container.plotly {
        height: 100%;
      }
      .display-value {
        font-weight: 700;
        color: #000000;
        z-index: 8;
        position: absolute;
        top: 36%;
        left: 30.8%;
        display: flex;
        width: 38%;
        background-repeat: no-repeat;
        background-size: 35%;
        background-position-y: 3px;
        background-position-x: 0;
        flex-direction: column;
        align-items: center;
        .no-data {
          font-weight: 400;
          font-size: 38px;
          // padding-top: 16px;
        }
      }
      .display-value.no-color {
        top: 42%;
      }
      .wy-home-exp-pie-chart-subtitle{
        font-size: 14.22px;
        font-weight: 500;
        color: var(--site-font-tertiary-color);
      }
      .wy-home-exp-pie-chart-percent{
        font-size: 35px;
        font-weight: 400;
        color: #000000
      }
      span.target-percent {
        position: relative;
        left: 16px;
      }
      .wy-home-exp-pie-chart-target{
        width: 48px;
        font-size: 13px;
        height: 18px;
        color: var(--site-font-chart-color);
        padding-left: 5px;
        display: flex;
        align-items: center;
        background-size: 30%;
        position: relative;
        left: 5px;
        background-position-y: 2px;
        background-position-x: 2px;
        border-radius: 15px;
        background-repeat: no-repeat;
        background-image: url('../../../assets/icons/icon_target_black.svg')!important;
      }
      .wy-home-exp-pie-red{
        // background-color: #FBE4E3;
        color: #C11149;
        font-size: 35px;
        font-weight: 400;
        margin-top: 8px;
        margin-bottom: 8px;
      }
      .wy-home-exp-pie-no-color{
        background-color: transparent;
        font-size: 35px;
        font-weight: 400;
        color: var(--site-font-chart-color);
        margin-top: 8px;
        margin-bottom: 8px;
      }
      .wy-home-exp-pie-yellow{
        // background-color: #FBFCDB;
        font-size: 35px;
        font-weight: 400;
        color: #8A5608;
        margin-top: 8px;
        margin-bottom: 8px;
      }
      .wy-home-exp-pie-green{
        // background-color: #D9EEDF;
        color: #186731;
        font-size: 35px;
        font-weight: 400;
        margin-top: 8px;
        margin-bottom: 8px;
      }

    // .display-value {
    //   position: relative;
    //   width: 100%;
    //   top: -117px;
    //   text-align: center;
    //   cursor: pointer;
    // }
    }
  }
</style>